<template>
  <div :class="style.RL">
    <!--    <img src="$images/BGstart.png" alt="" />-->
    <div :class="style.leftPart">
      <div :class="style.background">
        <img src="$images/logoRL.svg" alt="" />
      </div>
    </div>
    <!--        <header>-->
    <!--            <img src="$images/logoRL.svg" alt="">-->
    <!--            <router-link v-if="getComponent == 'RegistrationComponents'" :to="'/authorization'"-->
    <!--                v-text="'Войти'" />-->
    <!--            <router-link v-else :to="'/registration'" v-text="'Регистрация'" />-->
    <!--        </header>-->
    <component :is="getComponent" />
  </div>
</template>
<script lang="ts">
import style from "./StartPage.module.scss";
import RegistrationComponents from "./components/registration/RegistrationComponents.vue";
import AuthorizationComponents from "./components/authorization/AuthorizationPage.vue";
import RegistrationConfirmComponents from "./components/registrationConfirm/RegistrationConfirmComponents.vue";
import {defineComponent} from "vue";

export default defineComponent({
  components: {
    RegistrationComponents,
    AuthorizationComponents,
    RegistrationConfirmComponents
  },
  data() {
    return {
      style
    };
  },
  computed: {
    getComponent() {
      return this.$route.meta?.children;
    }
  }
});
</script>
